import React from 'react';
import { Phone, Mail, Heart } from 'lucide-react';

const CounselorContact = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 via-blue-700 to-teal-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
              <Heart className="w-8 h-8 text-blue-600" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Need Professional Grief Counseling?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Compassionate, professional support tailored to your unique grief journey. 
              Reach out today - you don't have to walk this path alone.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-6">
            {/* Phone Contact */}
            <a 
              href="tel:3212620256"
              className="flex items-center gap-3 bg-blue-600 text-white px-8 py-4 rounded-xl hover:bg-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full md:w-auto justify-center group"
            >
              <Phone className="w-6 h-6 group-hover:rotate-12 transition-transform" />
              <div className="text-left">
                <div className="text-sm font-medium opacity-90">Call Now</div>
                <div className="text-lg font-bold">(321) 262-0256</div>
              </div>
            </a>

            {/* Email Contact */}
            <a 
              href="mailto:mentorsplace@gmail.com"
              className="flex items-center gap-3 bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-xl hover:bg-blue-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full md:w-auto justify-center group"
            >
              <Mail className="w-6 h-6 group-hover:scale-110 transition-transform" />
              <div className="text-left">
                <div className="text-sm font-medium opacity-90">Email Me</div>
                <div className="text-lg font-bold">mentorsplace@gmail.com</div>
              </div>
            </a>
          </div>

          <div className="text-center">
            <p className="text-gray-600 text-sm">
              Professional grief counseling and support services available
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounselorContact;
